
import IftaLabel from 'primevue/iftalabel';
import Button from 'primevue/button';
import { useWebStore } from '../stores/web';
import { onMounted } from 'vue';
import { storeToRefs } from 'pinia';
import PopupMainNavbar from '../components/navbar/PopupMainNavbar.vue';
import PopupAffiliateNavbar from '../components/navbar/PopupAffiliateNavbar.vue';

export default {
	name: 'Contact',
	components: {
		IftaLabel,
		Button,
	},
	setup() {
		const web = useWebStore();
		web.hydrate();

		const { webPermission } = storeToRefs(web);

		const clickLink = (link: string) => {
			if (!link) return;
			window.open(link, '_blank');
		};

		return {
			webPermission,
			clickLink,
		};
	},
};
